"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Dropdown = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormLabel = _interopRequireDefault(require("./FormLabel"));

var _excluded = ["children", "required", "labelTitle", "onChange", "onBlur", "field", "hasError", "errorMessage", "value"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Container = _styledComponents.default.div.withConfig({
  displayName: "FormDropdown__Container",
  componentId: "sc-u6wk7n-0"
})(["text-align:left;"]);

var DropdownWrapper = _styledComponents.default.div.withConfig({
  displayName: "FormDropdown__DropdownWrapper",
  componentId: "sc-u6wk7n-1"
})(["position:relative;&:after{content:'';width:6px;height:6px;position:absolute;top:0.9rem;right:1rem;border:none;border-right:2px solid ", ";border-top:2px solid ", ";transform:rotate(135deg);pointer-events:none;}"], function (props) {
  return props.theme.grey3;
}, function (props) {
  return props.theme.grey3;
});

var Error = _styledComponents.default.p.withConfig({
  displayName: "FormDropdown__Error",
  componentId: "sc-u6wk7n-2"
})(["color:", ";font-size:1.2rem;margin:0.2rem 0 0;"], function (props) {
  return props.theme.red;
});

var Dropdown = _styledComponents.default.select.withConfig({
  displayName: "FormDropdown__Dropdown",
  componentId: "sc-u6wk7n-3"
})(["font-family:", ";font-size:1.3rem;font-weight:600;line-height:1.2;color:", ";appearance:none;width:100%;border-radius:2px;background:white;border:1px solid ", ";height:3rem;padding:0.5rem 3rem 0.5rem 0.8rem;&:focus{outline:none;border-color:", ";box-shadow:0 0 3px rgba(10,123,228,0.5);}&:-moz-focusring{color:transparent;text-shadow:0 0 0 #000;}"], function (props) {
  return props.theme.fontBody;
}, function (props) {
  return props.theme.grey3;
}, function (props) {
  return props.noBorder ? 'transparent' : props.theme.grey2;
}, function (props) {
  return props.theme.accentColor;
});

exports.Dropdown = Dropdown;

var FormDropdown = function FormDropdown(_ref) {
  var children = _ref.children,
      required = _ref.required,
      labelTitle = _ref.labelTitle,
      _onChange = _ref.onChange,
      _onBlur = _ref.onBlur,
      field = _ref.field,
      hasError = _ref.hasError,
      errorMessage = _ref.errorMessage,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(Container, null, labelTitle && /*#__PURE__*/_react.default.createElement(_FormLabel.default, {
    required: required,
    labelTitle: labelTitle
  }), /*#__PURE__*/_react.default.createElement(DropdownWrapper, null, /*#__PURE__*/_react.default.createElement(Dropdown, _extends({}, props, {
    value: value,
    onChange: function onChange(e) {
      return !!_onChange && _onChange(e, field);
    },
    onBlur: function onBlur(e) {
      return !!_onBlur && _onBlur(e, field);
    }
  }), children)), hasError && /*#__PURE__*/_react.default.createElement(Error, null, errorMessage));
};

FormDropdown.propTypes = {
  /** This is the options in the select */
  children: _propTypes.default.any,

  /** This is the required attribute */
  required: _propTypes.default.bool,

  /** This is the label */
  labelTitle: _propTypes.default.string,

  /** Callback function for whenever a change */
  onChange: _propTypes.default.func,

  /** Set to true for a borderless dropdown */
  noBorder: _propTypes.default.bool,

  /** If validation fails, this should be true */
  hasError: _propTypes.default.bool,

  /** If validation fails, this should have a value */
  errorMessage: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  field: _propTypes.default.string,
  value: _propTypes.default.string
};
FormDropdown.defaultProps = {
  required: false,
  noBorder: false
};
var _default = FormDropdown;
exports.default = _default;